import React from 'react';
import { oneOfType, number, string, bool } from 'prop-types';

export default function SimpleCell({ value }) {
  return <p>{value ? String(value) : '-'}</p>;
}

SimpleCell.propTypes = {
  value: oneOfType([string, number, bool, () => null]),
};

SimpleCell.defaultProps = {
  value: null,
};
